interface IScoreOption {
  value: string;
  coeficient: number;
  handicap?: string;
}

export type IScoreOptions = IScoreOption[];

export const orderOptions = (options: IScoreOptions): IScoreOptions => {
  const win = [];
  const equal = [];
  const lose = [];

  options.sort(
    (a, b) =>
      Number(a.handicap?.split('-').join('')) -
      Number(b.handicap?.split('-').join(''))
  );

  for (const option of options) {
    const arrHand = option.handicap?.split('-').map(n => Number(n));

    if (arrHand) {
      if (arrHand[0] > arrHand[1]) {
        win.push(option);
      } else if (arrHand[0] < arrHand[1]) {
        lose.push(option);
      } else {
        equal.push(option);
      }
    }
  }

  const all = [];
  const maxLength = Math.max(win.length, equal.length, lose.length);

  for (let i = 0; i < maxLength; i++) {
    all.push(win[i], equal[i], lose[i]);
  }

  return all;
};
